module.exports = __webpack_public_path__ + "static/meet-desktop-en-6e27975006eb6ac4f163c7daca3acc16.png";